import { css } from '@emotion/react';
import { AlignType } from './Popup';

export const wrapper = (top: number, align: AlignType) => css`
  position: absolute;
  top: ${top}px;
  ${align}: 0;
  border-radius: 4px;
  box-shadow: 0 8px 16px 0 rgba(33, 37, 41, 0.15), 0 0 0 1px var(--gray-100),
    0 1px 4px 0 rgba(0, 0, 0, 0.15);
  background-color: var(--white);
  visibility: visible;
  opacity: 1;
  transform: scale(1);
  transform-origin: left top;
  transition: transform 0.12s ease, opacity 0.12s ease;
  z-index: var(--z-popup);
`;

export const invisible = css`
  visibility: hidden;
  opacity: 0;
  transform: scale(0.5);
`;
